
import { CheckCircle, XCircle } from "lucide-react";
import type { MenuItem } from "../types";

export const inclusionsSection: MenuItem = {
  title: "شمول",
  href: "#",
  icon: CheckCircle,
  color: "from-teal-500 to-teal-600",
  subItems: [
    {
      title: "البرنامج يشمل",
      href: "/package-inclusions",
      icon: CheckCircle,
      color: "from-green-500 to-green-600",
    },
    {
      title: "البرنامج لا يشمل",
      href: "/package-exclusions",
      icon: XCircle,
      color: "from-red-500 to-red-600",
    },
  ],
};
